import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {TableButtonConfig} from "../../../../model/api/table-button-config";
import {FormFieldGroupConfig} from "../../../../model/api/form-field-group-config";
import {AppConfigService} from "../../../../services/app-config.service";
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {Order} from "../../../../model/clearing/order";
import {TableEditColumnConfig} from "../../../../model/api/table-edit-column-config";
import {OrderAmendmentListRequest} from "../../../../model/data-amendment/order-amendment-list-request";
import {OrderAmendmentService} from "../../../../services/data-amendment/order-amendment.service";
import {DateTime} from "luxon";
import {BatchUpdateRequest} from "../../../../model/api/batch-update-request";
import {FieldsService} from "../../../../services/common/fields-service";
import {ProgressTracker} from "../../../../model/api/progress-tracker";
import {
  OrderAmendmentTableConfigService
} from "../../../../services/data-amendment/order-amendment-table-config.service";
import {
  OrderAmendmentDataLoadingService
} from "../../../../services/data-amendment/order-amendment-data-loading.service";
import {OrderAmendmentFormConfigService} from "../../../../services/data-amendment/order-amendment-form-config.service";
import {CcTableEditComponent} from "../../../../crystal-elements/table-edit/cc-table-edit.component";

@Component({
  selector: 'app-order-amendment-table',
  templateUrl: './order-amendment-table.component.html',
  styleUrls: ['./order-amendment-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderAmendmentTableComponent extends CcBaseComponent {

  FieldTypes = FormFieldConfig.TYPE;

  tableConfig: TableEditColumnConfig[] = [];

  headerButtonConfig: TableButtonConfig[] = [];

  records: Order[] = [];
  formRecord: Order;
  recordsChange = new EventEmitter<Order[]>();

  selectedRecords: any[];

  batchUpdateDialogVisible: boolean = false;
  batchFormRecord: Order;

  totalRecords: number = 0;
  inProgressCount: number = 0;

  tableLoading: boolean = true;
  settingsFormLoadingProgressValue: number = 100;

  tableCurrentRequest: OrderAmendmentListRequest;

  @Input()
  transPartKey: string;
  @Input()
  visible: boolean = true;
  formConfig: FormFieldGroupConfig[] = [];

  @ViewChild('ccTable')
  public ccTable: CcTableEditComponent;

  tracker: ProgressTracker;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              protected orderAmendmentService: OrderAmendmentService,
              protected appConfigService: AppConfigService,
              translateService: TranslateService,
              protected fieldsService: FieldsService,
              protected tableConfigService: OrderAmendmentTableConfigService,
              protected formConfigService: OrderAmendmentFormConfigService,
              protected dataLoadingService: OrderAmendmentDataLoadingService) {
    super(cdref, messageService, translateService);

  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.tracker = this.fieldsService.createTracker();

    this.tracker.progress.subscribe(value => {
      this.settingsFormLoadingProgressValue = value;
    });

    this.dataLoadingService.loadData(this);
  }

  protected initConfigs() {
    super.initConfigs();
    this.tableCurrentRequest = {
      businessDate: DateTime.now().minus({days: DateTime.now().weekday === 1 ? 3 : 1}).toFormat('dd/MM/yyyy'),
      moneyOwner: undefined,
      customerCode: undefined,
      accountCode: undefined,
      reference: undefined,
      first: 0,
      rows: 1000,
      sortOrder: -1,
      sortField: 'modificationDate'
    };


    this.tableConfig = this.tableConfigService.loadConfig(this);
    this.formConfig = this.formConfigService.loadConfig(this);;
  }

  public refreshTable() {
    this.records = [];
    setTimeout(() => {
      this.reLoadRecords();
    });
  }

  public reLoadRecords() {
    if (this.destroyed)
      return;

    setTimeout(() => {
      this.tableLoading = true;
      this.settingsFormLoadingProgressValue++;
      this.markForCheck();
    });
    this.ccTable.reloadTableValueMap();
    if (!this.tableCurrentRequest.moneyOwner) {
      this.tableCurrentRequest.moneyOwner = undefined;
    }
    if (!this.tableCurrentRequest.customerCode) {
      this.tableCurrentRequest.customerCode = undefined;
    }
    if (!this.tableCurrentRequest.accountCode) {
      this.tableCurrentRequest.accountCode = undefined;
    }
    this.orderAmendmentService.list(this.tableCurrentRequest).subscribe(tableRecordResult => {
        if (tableRecordResult.success) {
          tableRecordResult.records.forEach(order => {
            order['accountName'] = order.account ? order.account.name : '';
            order['accountType'] = order.account ? order.account.type : '';
            order['accountReference1'] = order.account ? order.account.reference1 : '';
            order['accountReference2'] = order.account ? order.account.reference2 : '';
            order['accountReference3'] = order.account ? order.account.reference3 : '';
            if (order.businessDate)
              order.businessDate = new Date(order.businessDate);
            if (order.clearingDate)
              order.clearingDate = new Date(order.clearingDate);
            if (order.executionDate)
              order.executionDate = new Date(order.executionDate);
          });
          this.records = [];
          this.totalRecords = tableRecordResult.total;
          this.inProgressCount = 0;
          this.records = [...tableRecordResult.records];
          this.recordsChange.emit(this.records);
          this.apiMessage(tableRecordResult);
          setTimeout(() => {
            this.tableLoading = false;
            this.settingsFormLoadingProgressValue--;
            this.markForCheck();
          });

        } else {
          this.errorMessage(tableRecordResult.message);
          setTimeout(() => {
            this.tableLoading = false;
            this.settingsFormLoadingProgressValue--;
            this.markForCheck();
          });
        }
        //refresh
        this.tableCurrentRequest.syncMetadata = tableRecordResult.syncMetadata;
        this.ccTable.reloadTableValueMap();
        this.markForCheck();
      }
    );
  }

  onRowDblClick($event: any) {
  }

  formRecordChanged(formRecord: any) {
  }


  applyBatchToRecordsTable(request: BatchUpdateRequest<Order>) {
    this.records.forEach(record => {
      if (request.recordIds.includes(record.id)) {
        request.fieldToUpdate.forEach(field => {
          record[field] = request.recordToApply[field];
        });
        record['hasChanged'] = true;
      }
    });
    this.records = [...this.records];
    this.batchUpdateDialogVisible = false;
    this.ccTable.reloadTableValueMap();
    this.markForCheck();
    // this.infoMessage('page.' + this.transPartKey + '.message.saved');
  }

  reloadTableValueMap(){
    this.ccTable.reloadTableValueMap();
    this.markForCheck();
  }

  showBatchUpdate() {
    if (!this.records || this.records.length == 0) return;
    if (!this.selectedRecords || this.selectedRecords.length === 0) {
      this.selectedRecords = [...this.records];
    }
    this.batchFormRecord = {...this.selectedRecords[0]};
    // this.batchFormRecord['account_name'] = this.batchFormRecord.account ? this.batchFormRecord.account.name : '';
    // this.batchFormRecord['account_reference1'] = this.batchFormRecord.account ? this.batchFormRecord.account.reference1 : '';
    this.batchUpdateDialogVisible = true;
  }

  onselectionchanged($event: any) {
  }

  recordChange(record: any) {
    record['hasChanged'] = true;
  }

  filterAccounts() {

  }
}
